import type { TFunction } from "i18next"
import { uniq } from "lodash"

import { ICatalog } from "shared/hubrise/models"

export type TagOption = { value: string; label: string }

/**
 * Returns possible tags for a product. This includes default tags and user-defined tags on any product.
 * Can be quite slow if the catalog is large.
 */
export const tagOptions = (t: TFunction, catalog: ICatalog): Array<TagOption> => {
  const customProductTags = uniq(catalog.data.products.flatMap((product) => product.tags))
    .filter((tag) => !(DEFAULT_TAGS as ReadonlyArray<string>).includes(tag))
    .sort((a, b) => a.localeCompare(b))

  return [
    ...customProductTags.map((value) => ({ label: value, value })),
    ...DEFAULT_TAGS.map((value) => ({ label: t(`tags.default.${value}`), value })),
  ]
}

export const DEFAULT_TAGS = [
  "alcoholic",
  "deal_only",
  "gluten_free",
  "spicy_1",
  "spicy_2",
  "spicy_3",
  "vegan",
  "vegetarian",
  "half_half",
] as const
